<tec-modal
    [isVisible]="true"
    [title]="'PROCESSES.MENU.UNLOCK_IDENTITY' | translate"
    [buttonPrimaryLabel]="'BUTTON.UNBLOCK' | translate"
    [buttonSecondaryLabel]="'BUTTON.CANCEL' | translate"
    [buttonPrimaryStyle]="true"
    (closeEvent)="closeModal($event)"
>
    <ng-container body [formGroup]="form">
        @if (errorMsg) {
            <tec-alert status="error" [msg]="errorMsg" (closeAlert)="errorMsg = ''" />
        }
        <div class="body__text">
            <span>{{ 'PROCESSES.UNLOCK_IDENTITY_MODAL.SELECT_PARAMETERS' | translate }}</span>
        </div>
        <form [formGroup]="form" class="unlock-parameters-form">
            @if (showOcrUnlockOption) {
                <tec-card-select
                    formGroupName="ocr"
                    [tagImg]="{ icon: 'icon-card' }"
                    [title]="'PROCESSES.UNLOCK_IDENTITY_MODAL.OCR_TITLE' | translate"
                    [tags]="
                        unlockedIdentityParams.includes('ocr')
                            ? [{ label: 'PROCESSES.UNLOCK_IDENTITY_MODAL.ACTIVE' | translate, status: 'success' }]
                            : [{ label: 'PROCESSES.UNLOCK_IDENTITY_MODAL.BLOCKED' | translate, status: 'error' }]
                    "
                    [disabled]="form.get('ocr')?.disabled"
                    [selected]="form.get('ocr')?.value"
                    (selectedChange)="form.get('ocr').patchValue($event)"
                />
            }
            @if (showIpUnlockOption) {
                <tec-card-select
                    formGroupName="ip"
                    [tagImg]="{ icon: 'icon-map-pin' }"
                    [title]="'PROCESSES.UNLOCK_IDENTITY_MODAL.IP_TITLE' | translate"
                    [tags]="
                        unlockedIdentityParams.includes('ip')
                            ? [{ label: 'PROCESSES.UNLOCK_IDENTITY_MODAL.ACTIVE' | translate, status: 'success' }]
                            : [{ label: 'PROCESSES.UNLOCK_IDENTITY_MODAL.BLOCKED' | translate, status: 'error' }]
                    "
                    [disabled]="form.get('ip')?.disabled"
                    [selected]="form.get('ip')?.value"
                    (selectedChange)="form.get('ip').patchValue($event)"
                />
            }
            @if (showFaceUnlockOption) {
                <tec-card-select
                    formGroupName="face"
                    [tagImg]="{ icon: 'icon-user' }"
                    [title]="'PROCESSES.UNLOCK_IDENTITY_MODAL.FACE_TITLE' | translate"
                    [tags]="
                        unlockedIdentityParams.includes('face')
                            ? [{ label: 'PROCESSES.UNLOCK_IDENTITY_MODAL.ACTIVE' | translate, status: 'success' }]
                            : [{ label: 'PROCESSES.UNLOCK_IDENTITY_MODAL.BLOCKED' | translate, status: 'error' }]
                    "
                    [disabled]="form.get('face')?.disabled"
                    [selected]="form.get('face')?.value"
                    (selectedChange)="form.get('face').patchValue($event)"
                />
            }
        </form>
    </ng-container>
</tec-modal>
